import { createContext } from 'react';

const navigationContext = createContext();

export default navigationContext;